import { styled } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";
import LocalizedLink from "../../components/localized-link";

const CustomList = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  overflowX: "auto",
  flexWrap: "nowrap",
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.only("xs")]: {
    width: "100vw",
    marginLeft: "-16px",
    paddingLeft: "16px"
  }
}));

const CustomLink = styled(LocalizedLink)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: theme.palette.grey[300],
  borderRadius: "24px",
  height: "36px",
  maxWidth: "none",
  fontSize: "12px",
  fontFamily: "Roobert, Arial",
  lineHeight: 1,
  textTransform: "uppercase",
  fontWeight: 600,
  letterSpacing: "1px",
  padding: "4px 20px",
  whiteSpace: "nowrap",
  marginRight: "8px",
  "&:hover": {
    backgroundColor: theme.palette.grey[400]
  },
  [theme.breakpoints.down("sm")]: {
    borderRadius: "22px",
    height: "30px",
    fontSize: "12px",
    marginRight: "6px"
  },
  [theme.breakpoints.down("xs")]: {
    borderRadius: "18px",
    height: "26px",
    fontSize: "11px",
    marginRight: "6px",
    padding: "3px 18px"
  }
}));

const CustomLabel = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.palette.grey[600],
  height: "36px",
  fontSize: "12px",
  fontFamily: "Roobert, Arial",
  lineHeight: 1,
  textTransform: "uppercase",
  fontWeight: 600,
  letterSpacing: "1px",
  padding: "4px 20px 4px 0",
  [theme.breakpoints.down("sm")]: {
    display: "none"
  }
}));

type Props = Queries.ShopNavigationFragmentFragment;

function ShopNavigation({ links }: Props) {
  if (!links) return null;
  return (
    <CustomList>
      <CustomLabel>Browse</CustomLabel>
      {links.map(link => (
        <CustomLink key={link.linkPath} to={link.linkPath}>
          {link.label}
        </CustomLink>
      ))}
    </CustomList>
  );
}

export const ShopNavigationFragment = graphql`
  fragment ShopNavigationFragment on DatoCmsCModuleShopNavigation {
    links {
      label
      linkPath
    }
    model {
      apiKey
    }
  }
`;

export default React.memo(ShopNavigation);
